/**
 * Bouton favori (coeur) sur les cartes produit de la page collection.
 * Stocke la liste en localStorage, par appareil/navigateur. Aucune dépendance.
 */
const STORAGE_KEY = 'wouska:wishlist';
const HEART_PATH = 'M12 20s-7-4.4-9.5-9C.7 7.4 2.6 4 6 4c2 0 3.6 1.1 4.5 2.6C11.4 5.1 13 4 15 4c3.4 0 5.3 3.4 3.5 7-2.5 4.6-9.5 9-9.5 9Z';

function readWishlist() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

function writeWishlist(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    /* stockage indisponible (navigation privée, quota) : dégrade sans erreur */
  }
}

class WouskaWishlistButton extends HTMLElement {
  connectedCallback() {
    if (this.querySelector('button')) return;

    const id = this.dataset.productId;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'wc-wish';
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute(
      'aria-label',
      this.dataset.labelAdd || 'Ajouter aux favoris'
    );
    button.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${HEART_PATH}"/></svg>`;
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.#toggle(id, button);
    });

    this.appendChild(button);
    this.#sync(id, button);
  }

  #toggle(id, button) {
    const list = readWishlist();
    const index = list.indexOf(id);
    if (index === -1) {
      list.push(id);
    } else {
      list.splice(index, 1);
    }
    writeWishlist(list);
    this.#applyState(button, index === -1);
  }

  #sync(id, button) {
    this.#applyState(button, readWishlist().includes(id));
  }

  #applyState(button, active) {
    button.dataset.active = String(active);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute(
      'aria-label',
      active
        ? this.dataset.labelRemove || 'Retirer des favoris'
        : this.dataset.labelAdd || 'Ajouter aux favoris'
    );
  }
}

if (!customElements.get('wouska-wishlist-button')) {
  customElements.define('wouska-wishlist-button', WouskaWishlistButton);
}
